import update from 'immutability-helper'
import { FETCH_RENT_LISTING_REQUEST } from 'v2/spas/prospective-property/rent-listings/redux/action-types.tsx'
import { FETCH_RENT_LISTING_SUCCESS } from 'v2/spas/prospective-property/rent-listings/redux/action-types.tsx'
import { FETCH_RENT_LISTING_FAILURE } from 'v2/spas/prospective-property/rent-listings/redux/action-types.tsx'
// import { UPDATE_RENT_LISTING_REQUEST } from 'v2/spas/prospective-property/rent-listings/redux/action-types.tsx'
import { UPDATE_RENT_LISTING_SUCCESS } from 'v2/spas/prospective-property/rent-listings/redux/action-types.tsx'
// import { UPDATE_RENT_LISTING_FAILURE } from 'v2/spas/prospective-property/rent-listings/redux/action-types.tsx'

const initialState = {
  status: 'requested',
  error: '',
  rentListing: {}
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_RENT_LISTING_REQUEST: {
      return update(state, {
        status: { $set: 'requested' },
      })
    }

    case FETCH_RENT_LISTING_FAILURE: {
      return update(state, {
        status: {
          $set: 'error',
        },
        error: { $set: action.payload.error },
      })
    }

    case FETCH_RENT_LISTING_SUCCESS: {
      return update(state, {
        status: { $set: 'success' },
        rentListing: {
          $set: action.payload.rentListing,
        }
      })
    }

    // case UPDATE_RENT_LISTING_REQUEST: {
    //   return update(state, {
    //     updateRentListingStatus: { $set: 'requested' },
    //   })
    // }

    // case UPDATE_RENT_LISTING_FAILURE: {
    //   return update(state, {
    //     updateRentListingStatus: {
    //       $set: 'error',
    //     },
    //     updateRentListingError: { $set: action.payload.error },
    //   })
    // }

    case UPDATE_RENT_LISTING_SUCCESS: {
      return update(state, {
        rentListing: {
          $set: action.payload.rentListing,
        }
      })
    }

    default:
      return state
  }
}